var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M11.0711 19.1421L12.4853 17.7279L7.75736 13H20V11H7.89949L12.4853 6.41421L11.0711 5L4 12.0711L11.0711 19.1421Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }